// eslint-disable-next-line
export const LOCALE_PREFIX = 'components.ContextBurger'
